import twLocale from 'element-ui/lib/locale/lang/zh-TW' //引入element語言包
export default {
	all:{
		jiantizhongwen:'簡體中文',
		fantizhongwen:'繁體中文',
		yingwen:'英文',
		yuyanxuanze:'語言選擇',
		shezhi:'設置',
		xiugaimima:'修改密碼',
		yinsizhengce:'私隱政策',
		guanyuwomen:'關於我們',
		mimashuoming:'密碼必須是8-20位大小寫字母和數字組合，不能是純數字或純字母',
		qingshurujiumima:'請輸入舊密碼',
		qingshuruxinmima:'請輸入新密碼',
		quedingxiugai:'確定修改',
		
		shouye:'首頁',
		zhibo:'直播',
		wode:'我的',
		xitongxiaoxi:'系統消息',
		wodedingdan:'我的訂單',
		bangzhufankui:'幫助反饋',
		xiugaiziliao:'修改資料',
		xiaofeimingxi:'消費明細',
		zhibojilu:'直播記錄',
		tijiao:'提交',
		caozuochenggong:'操作成功',
		tishi:'提示',
		quedingtuichudenglu:'確定退出登錄嗎？',
		queding:'確定',
		wentibangzhu:'問題幫助',
		woyaofankui:'我要反饋',
		fankuiwenti:'反饋問題',
		qingmiaoshuniyaofankuidewenti:'請描繪你要反饋的問題...',
		sousuo:'搜尋',
		sousuoniganxingqudeneirong:'搜尋你感興趣的內容',
		zhibojianbiaoti:'直播間標題',
		zhibojianbeijing:'直播間背景',
		zhibojianbiaoqian:'直播間標籤',
		zhibojianhuazhi:'直播間畫質',
		geinidezhibojianqugemingziba:'給你的直播間取一個名字吧~',
		qingshurukaibomiyao:'請輸入開播秘鑰',
		kaishizhibo:'開始直播',
		shengyin:'聲音',
		liwutexiao:'禮物特效',
		gengduo:'更多',
	    gouwuche:'購物車',
		zaixianguanzhong:'在線觀眾',
		danmushuoming:'平台嚴禁未成年人充值打賞，嚴禁以陪玩等方式誘導打賞私下交易，嚴禁涉黃涉政、謾罵等內容，請注意財產安全，謹防網絡詐騙，理性消費。',
		tianjiaguanliyuan:'添加管理員',
		jinyan:'禁言',
		jiechuejinyan:'解除禁言',
		tichufangjian:'踢出房間',
		shangpinxiangqing:'商品詳情',
		lijijiagou:'立即加購',
		xuanzeguige:'選擇規格',
		quanbuliwu:'全部禮物',
		ge:'個',
		bi:'幣',
		guanliyuan:'管理員',
		kuaijieduanyu:'快捷短語',
		gonggao:'公告',
		xinzengkuaijieduanyu:'新增快捷短語',
		qingshuru:'請輸入',
		wangjimima:'忘記密碼',
		youxiangzhuce:'郵箱註冊',
		huoquyanzhengma:'獲取驗證碼',
		qingshuruningdeyouxiangzhanghao:'輸入您的郵箱賬號',
		qingshuruyanzhengma:'請輸入驗證碼',
		qingshurumima:'請輸入密碼',
		mimadenglu:'密碼登錄',
		woyiyuedubingtongyi:'我已閱讀並同意',
		yonghuxieyi:'使用者協議',
		yinsixieyi:'隱私協議',
		denglu:'登錄',
		chongxindenglu:'重新登陸',
		xiayibu:'下一步',
		haimeizhanghao:'還沒有帳號',
		quzhuce:'去註冊',
		yiyouzhanghao:'已有帳號',
		qudenglu:'去登錄',
		shezhijibenxinxi:'設置基本資訊',
		nichengtishi:'僅支持字母、數字和標點符號，最少6位，不能使用空格',
		shezhiyonghuming:'設置用戶名',
		yonghumingtishi:'用戶名為6-18位，大小寫字母或數字',
		shezhijiaoyimima:'設置交易密碼',
		jiaoyimimatishi:'交易密碼必须是6位數字組合',
		qingxuanze:'請選擇',
		yaoqingma:'邀請碼（選填）',
		qingshuruyaoqingma:'輸入邀請碼',
		shezhixinmima:'設置新密碼',
		xuanzeningdeguojia:'選擇您的國家',
		zhuce:'註冊',
		qingshuruyonghuming:'請輸入用戶名',
		gaoqinghuazhi:'高清畫質',
		putonghuazhi:'普通畫質',
		kaishizhibo:'開始直播',
		zengsong:'贈送',
		jinrulezhibojian:'進入直播間',
		shuodianshenmene:'說點什麼呢...',
		zanwushuju:'暫無數據',
		songgei:'送給',
		huifang:'回放',
		quedingtuichudengluma:'確定退出登錄嗎?',
		xunibi:'虛擬幣',
		quanbu:'全部',
		appxiazai:'APP下載',
		dingdanjine:'訂單金額',
		dingdanbianhao:'訂單編號',
		chuangjianshijian:'創建時間',
		zhubozanshilikai:'主播暫時離開',
		mashanghuilai:'馬上回來',
		guojianzhuoxiazai:'國際安卓下載',
		anzhuoxiazai:'安卓下載',
		guojipingguoxiazai:'國際蘋果下載',
		pingguoxiazai:'蘋果下載',
		quanbushangpin:'全部商品',
		yiqiangguang:'已搶光',
		jiagou:'加購',
		shangpinxiangqing:'商品詳情',
		lijijiagou:'立即加購',
		yixuan:'已選',
		xuazeguige:'選擇規格',
		shangchuanzhong:'上傳中',
		shangchuanshibai:'上傳失敗',
		shifouquedingjieshuzhibo:'是否確定關閉直播？',
		qingyuedubingtongyiyonghuxieyiheyinsixieyi:'請閱讀並同意用戶協議和隱私協議！'
	},
}
 


// WEBPACK FOOTER //
// ./src/i18n/langs/tw.js